module.exports = __webpack_public_path__ + "static/media/yournamepro.png.png.7b48469a.webp";